import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Modal, Button, Container, Row, Col, Spinner } from "react-bootstrap";
import { BsCalendarMinusFill, BsExclamationCircleFill, BsPlusLg } from "react-icons/bs";
import style from "../Modal.module.scss";
import "../../../pages/DataCollection/style.css";
import { TODIS_FORM_FIELD, TODIS_FORM_FIELD_MULTISELECT, TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE } from "../../Forms";
import { Form, Formik } from "formik";
import { TODIS_USERS, USER } from "../../../.config/modals";
import { OrganizationsService } from "../../../HttpService/OrganizationService";
import Swal from "sweetalert2";
import { LOADING } from "../../Loading/Loading";

const MODAL_USER = forwardRef(({refreshRequest, titleFormUser, ...restProps}, ref) => {

    const initialState = "create"
    const [loading, setLoading] = useState(false)
    const [typeAction, setTypeAction] = useState(initialState)
    const [initValue, setInitValue] = useState(USER)
    const [organizations, setOrganizations] = useState([])
    const [roles, setRoles] = useState([])
    const [responseD, setResponseD] = useState(false)

    const getOrganizations = async() => {
        try {
            let resR = await new OrganizationsService("organization/organizations").getDataOrganizations();
            if(resR){
                setOrganizations(resR);
            }
        } catch (error) {
            console.log("error listing roles", error);
        }
    }

    const changeOrganization = async(e, valueForm, setFieldValue) => {
        valueForm.roles = []
        setRoles([]);
        setResponseD(true);
        setFieldValue("organizationId", e.target.value)
        if(e.target.value != ""){
            try {
                let resR = await getRoles(e.target.value);
                if(resR){
                    setRoles(resR);
                    setResponseD(false);
                } else {
                    setResponseD(true)
                }
            } catch (error) {
                console.log("error listing roles", error);
            }
        }else{
            setResponseD(false);
        }

    }

    const getRoles = async (value) => {
        try {

            return await new OrganizationsService("organization/roles/" + value).getDataOrganizations();

        } catch (error) {
            console.log("error listing roles", error);
        }
    } 

    const onCreate = async (values) => {
        let rolesUser = [];
        setLoading(true)

        // Mostrar Swal de carga
        const loadingSwalTimeout = setTimeout(() => {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we create the user.',
                allowOutsideClick: false,
                //showCancelButton: true,
                //cancelButtonText: 'Close',
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }, 50);


        try {
            values.roles.map(item => rolesUser.push(item.value ? item.value : item.roleId))
            const res = await new OrganizationsService("user/create").createUser({...values, roles: rolesUser});
            if (res.status == 201) {
                setLoading(false)
                refreshRequest()
                onClose()
                clearTimeout(loadingSwalTimeout);
                Swal.close();
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully created User',
                    showConfirmButton: false,
                    timer: 1500
                    })
            } else {
                console.log("error in create User", res);
                clearTimeout(loadingSwalTimeout);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An error occurred while creating the user.",
                    showConfirmButton: true
                });
            }
        } catch (error) {
            console.log("error in create User", error);
            clearTimeout(loadingSwalTimeout);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An unexpected error occurred while creating the user.",
                showConfirmButton: true
            });
        }
    }

    const onUpdate = async (values) => {
        let rolesUser = [];
        setLoading(true)

        // Mostrar Swal de carga
        const loadingSwalTimeout = setTimeout(() => {
            Swal.fire({
                title: 'Processing...',
                text: 'Please wait while we update the user.',
                allowOutsideClick: false,
                //showCancelButton: true,
                //cancelButtonText: 'Close',
                didOpen: () => {
                    Swal.showLoading();
                }
            });
        }, 50);


        try {
            //values.roles.map(item => rolesUser.push(item.value ? item.value : item.roleId))
            values.roles.map(item => rolesUser.push(item.id ? item.id : item.value));
            const res = await new OrganizationsService("user/update").updateUser({ ...values, roles: rolesUser });
            if (res.status == 201) {
                setLoading(false)
                refreshRequest()
                onClose()
                clearTimeout(loadingSwalTimeout);
                Swal.close();
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Successfully updated User',
                    showConfirmButton: false,
                    timer: 1500
                    })
            } else {
                console.log("error in update User", res);
                clearTimeout(loadingSwalTimeout);
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "An error occurred while updating the user.",
                    showConfirmButton: true
                });
            }
        } catch (error) {
            console.log("error in update User", error);
            clearTimeout(loadingSwalTimeout);
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "An unexpected error occurred while updating the user.",
                showConfirmButton: true
            });
        }
    }

    const detailUser = async (id, typeAction) => {
        setLoading(true)
        try {
            const res = await new OrganizationsService("user/users/" + id).getDetailsUser();
            if(res){
                let resR = await getRoles(res.organizationId);
                if(resR){
                    setRoles(resR);
                    setInitValue(res)
                    setResponseD(false)
                    setLoading(false)
                } else {
                    setLoading(false)
                    console.log("error listing roles");
                }
                setTypeAction(typeAction)
            }
            // const newValue = {
            //     firstName: "PRUEBA NAME",
            //     lastName: "LASTNAME",
            //     userName: "USER",
            //     email: "PRUEBA@IDOM.COM",
            //     password: "PASSWORD",
            //     phNo: "970414708",
            //     position: "POSITION",
            //     address: "DIRECCION",
            //     organizationId: 2,
            //     roles: [{roleId: 1, roleName: "REGIONALUSER"}, {roleId: 2, roleName: "COORDINATOR"}, {roleId: 3, roleName: "ADMIN"}]
            // }
            
        } catch (error) {
            console.log("error in update Organization", error)
        }
    }

    useEffect(() => {
        (async () => {
            await getOrganizations();
        })();
    }, []);

    useImperativeHandle(ref, () => ({
        detailUser
    }))

    const onClose = () => {
        setTypeAction(initialState)
        setInitValue(USER)
        restProps.onHide() 
    }

    return (
        <Modal
            {...restProps}
            onHide={() => { onClose() }}
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={style.todisModalContainer}
            dialogClassName={style.sizeModal70}
        >
            <Modal.Header closeButton className={style.modalHeader}>
                <Modal.Title id="contained-modal-title-vcenter" className={style.modalTitle}>
                    <BsCalendarMinusFill className="me-3" />{titleFormUser} User
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid className="todis-form-wrapper p-3" style={{height: loading ? "573px" : "100%"}}>
                {   
                !loading ?
                    <Row>
                        <Formik
                            enableReinitialize={true}
                            initialValues={initValue}
                            validationSchema={TODIS_USERS}
                            onSubmit={typeAction == "create" ? onCreate : onUpdate}>
                            {({ errors, touched, values, setFieldValue }) => (
                                <Form className="todis-form-content p-0">
                                    <Container>
                                        <Row>
                                            <Col lg={3}>
                                                <TODIS_FORM_FIELD id="firstName" label="FIRST NAME" name="firstName" disabled={typeAction == "view"}/>
                                                {errors.firstName && touched.firstName ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.firstName}</div>) : null}
                                            </Col>
                                            <Col lg={3}>
                                                <TODIS_FORM_FIELD id="lastName" label="LAST NAME" name="lastName" disabled={typeAction == "view"}/>
                                                {errors.lastName && touched.lastName ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.lastName}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD id="userName" label="USERNAME" name="userName" disabled={typeAction == "view"}/>
                                                {errors.userName && touched.userName ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.userName}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD id="email" label="EMAIL" name="email" disabled={typeAction == "view"}/>
                                                {errors.email && touched.email ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.email}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                {typeAction === "create" && (<TODIS_FORM_FIELD id="password" label="PASSWORD" name="password" disabled={typeAction == "view" || typeAction == "update"} />)}
                                                {errors.password && touched.password ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.password}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD id="phNo" label="PHONE NUMBER" name="phNo" disabled={typeAction == "view"}/>
                                                {errors.phNo && touched.phNo ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.phNo}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD id="position" label="POSITION" name="position" disabled={typeAction == "view"}/>
                                                {errors.position && touched.position ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.position}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD id="address" label="ADDRESS" name="address" disabled={typeAction == "view"}/>
                                                {errors.address && touched.address ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.address}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD_OPTIONS_WITH_CHANGE onchange={e => {changeOrganization(e, values, setFieldValue)}} id="organizationId" label="ORGANIZATION" placeholder="Select" name="organizationId" options={organizations} nameValue="id" nameDesc="name" disabled={typeAction == "view"}/>
                                                {errors.organizationId && touched.organizationId ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.organizationId}</div>) : null}
                                            </Col>
                                            <Col lg={6}>
                                                <TODIS_FORM_FIELD_MULTISELECT id="roles" label="ROLES" name="roles" options={roles} setFieldValue={setFieldValue} values={values} isLoading={responseD} disabled={typeAction == "view"}/>
                                                {errors.roles && touched.roles ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size="18" /></span>Error: {errors.roles}</div>) : null}
                                            </Col>
                                            <div className="todis-action-form">
                                                <Button variant="outline-danger" onClick={() => onClose()} className={style.todisBtnOutline}>DISCARD </Button>
                                            {
                                                typeAction == "create" || typeAction == "update" ?
                                                <Button variant="primary" className="todis-submit-btn bck-btn-secundary" type="submit" style={{margin: "0.5rem", textTransform: "uppercase"}}>{typeAction == "create" && <BsPlusLg className="me-3" />}{titleFormUser} USER </Button>
                                                : null
                                            }
                                            </div>
                                        </Row>
                                    </Container>
                                </Form>
                            )}
                        </Formik>
                    </Row> 
                    :
                    <LOADING/>
                    }
                </Container>
            </Modal.Body>
        </Modal>
    )
});

export { MODAL_USER };